import { render } from "./DashboardMobile.vue?vue&type=template&id=70725e88&scoped=true"
import script from "./DashboardMobile.vue?vue&type=script&lang=js"
export * from "./DashboardMobile.vue?vue&type=script&lang=js"

import "./DashboardMobile.vue?vue&type=style&index=0&id=70725e88&scoped=true&lang=css"

import exportComponent from "/Users/ranjanbajracharya/Documents/upwork/kaz/mbsm-pwa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70725e88"]])

export default __exports__